import { render, staticRenderFns } from "./regHoursVolChart_Block_3.vue?vue&type=template&id=2f9792c0&scoped=true&"
import script from "./regHoursVolChart_Block_3.vue?vue&type=script&lang=js&"
export * from "./regHoursVolChart_Block_3.vue?vue&type=script&lang=js&"
import style0 from "./regHoursVolChart_Block_3.vue?vue&type=style&index=0&id=2f9792c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9792c0",
  null
  
)

export default component.exports